/**
 * C2C REST API
 *
 * Query fiat transaction history via the C2C REST API.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ConfigurationRestAPI, RestApiResponse, sendRequest } from '@binance/common';
import { Api } from './modules/api';

import type { GetC2CTradeHistoryRequest } from './modules/api';

import type { GetC2CTradeHistoryResponse } from './types';

export class RestAPI {
    private configuration: ConfigurationRestAPI;
    private api: Api;

    constructor(configuration: ConfigurationRestAPI) {
        this.configuration = configuration;
        this.api = new Api(configuration);
    }

    /**
     * Generic function to send a request.
     * @param endpoint - The API endpoint to call.
     * @param method - HTTP method to use (GET, POST, DELETE, etc.).
     * @param queryParams - Query parameters for the request.
     * @param bodyParams - Body parameters for the request.
     *
     * @returns A promise resolving to the response data object.
     */
    sendRequest<T>(
        endpoint: string,
        method: 'GET' | 'POST' | 'DELETE' | 'PUT' | 'PATCH',
        queryParams: Record<string, unknown> = {},
        bodyParams: Record<string, unknown> = {}
    ): Promise<RestApiResponse<T>> {
        return sendRequest<T>(
            this.configuration,
            endpoint,
            method,
            queryParams,
            bodyParams,
            undefined,
            undefined
        );
    }

    /**
     * Generic function to send a signed request.
     * @param endpoint - The API endpoint to call.
     * @param method - HTTP method to use (GET, POST, DELETE, etc.).
     * @param queryParams - Query parameters for the request.
     * @param bodyParams - Body parameters for the request.
     *
     * @returns A promise resolving to the response data object.
     */
    sendSignedRequest<T>(
        endpoint: string,
        method: 'GET' | 'POST' | 'DELETE' | 'PUT' | 'PATCH',
        queryParams: Record<string, unknown> = {},
        bodyParams: Record<string, unknown> = {}
    ): Promise<RestApiResponse<T>> {
        return sendRequest<T>(
            this.configuration,
            endpoint,
            method,
            queryParams,
            bodyParams,
            undefined,
            undefined,
            { isSigned: true }
        );
    }

    /**
     * Get C2C Trade History
     *
     * Weight(IP): 1
     *
     * Security Type: USER_DATA
     *
     * Notes:
     * - The max interval between `startTimestamp` and `endTimestamp` is 30 days.
     * - If `startTimestamp` and `endTimestamp` are not sent, the recent 30 days' data is returned.
     * - You can only view data from the past 6 months. For all C2C orders, check `https://c2c.binance.com/en/fiatOrder`.
     *
     * @summary Get C2C Trade History (USER_DATA)
     * @param {GetC2CTradeHistoryRequest} requestParameters Request parameters.
     *
     * @returns {Promise<RestApiResponse<GetC2CTradeHistoryResponse>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @see {@link https://developers.binance.com/en/docs/catalog/investment-and-services-c2-c/api/rest-api/~#get-c2-ctrade-history Binance API Documentation}
     */
    getC2CTradeHistory(
        requestParameters: GetC2CTradeHistoryRequest = {}
    ): Promise<RestApiResponse<GetC2CTradeHistoryResponse>> {
        return this.api.getC2CTradeHistory(requestParameters);
    }
}
